<template>
  <div>
    <PatientFilterChip
      v-if="selected"
      :selected="selected"
      :label="selectedName"
      icon="mdi-pill"
      class="cursor-pointer"
      @click="select(null, null)"
    />
    <AutoCompleteModal v-else @selected="select">
      <template #trigger>
        <PatientFilterChip :selected="selected" label="Achats >" icon="mdi-pill" />
      </template>
    </AutoCompleteModal>
  </div>
</template>

<script lang="ts" setup>
import {
    SearchBarAutoCompleteItem
} from "@/auto-complete-searchbar/interfaces/ISearchBarAutoComplete";
import PatientFilterChip from "@/prescription/components/PatientFilterChip.vue";
import {ref} from "vue";
import AutoCompleteModal from "@/auto-complete-searchbar/components/AutoCompleteModal.vue";

defineProps({
    selected: {
        type: Boolean,
        required: true
    }
});

const emits = defineEmits(['selected']);

const open = ref(false);
const selectedName = ref<string>('');

/**
 * Select an item.
 * @param type  The type of the item.
 * @param data  The selected item.
 */
const select = (type: 'product' | 'laboratory' | 'range' | null, data: SearchBarAutoCompleteItem | null) => {
    emits('selected', type, data?.id || null);
    open.value = false;
    selectedName.value = data?.name || '';
};
</script>
